// @flow
import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Input,
  Modal,
  Row,
  Col,
  Switch,
} from 'antd';
import SimpleReactValidator from 'simple-react-validator';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  close: Function,
  submit: Function,
  visible: boolean,
  submitting: boolean,
  selectedGlobalRestrictedKey: Object,
};

const EditGlobalRestrictedKey = (props: Props) => {
  const {
    visible,
    close,
    submit,
    submitting,
    selectedGlobalRestrictedKey,
  } = props;

  const [, forceUpdate] = useState();
  const gid = selectedGlobalRestrictedKey ? selectedGlobalRestrictedKey.gid : '';
  const [isEnabled, setIsEnabled] = useState(selectedGlobalRestrictedKey ? selectedGlobalRestrictedKey.isEnabled : false);
  const [isPos, setIsPos] = useState(selectedGlobalRestrictedKey ? selectedGlobalRestrictedKey.isPos : false);
  const [disableButton, setDisableButton] = useState(false);
  const simpleValidator = useRef(new SimpleReactValidator());

  useEffect(() => {
    if (!submitting) {
      setDisableButton(false);
    }
  }, [submitting]);

  const isEnableChange = (value) => {
    setIsEnabled(value);
  };

  const isPosChange = (value) => {
    setIsPos(value);
  };

  const validate = (event) => {
    setDisableButton(true);
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    setDisableButton(formValid);
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    submit({
      gid,
      isEnabled,
      isPos,
    });
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={validate} disabled={disableButton}>Update</SpButton>,
      ]}
      title="Update GR Key"
    >
      <div className="px-4">
        <div className={submitting ? 'OVERLAY' : ''} />
        <div className="mb-3">
          <label htmlFor=""><SpH5>GID</SpH5></label>
          <Input
            placeholder="GID"
            value={gid}
            disabled
          />
        </div>
        <Row className="mb-3">
          <Col>
            <Switch
              className="mr-2"
              checked={isEnabled}
              onChange={isEnableChange}
            /> Enabled
          </Col>
        </Row>
        <Row>
          <Col>
            <Switch
              className="mr-2"
              checked={isPos}
              onChange={isPosChange}
            /> POS Driven Reconcilation
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  validator: state.loading.validator,
  submitting: state.loading.submitting,
  test: state.account.test,
});

// $FlowFixMe
export default connect(mapStateToProps, null)(EditGlobalRestrictedKey);
